// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3spNO","content":"styles_content__31dc1"};